import React from 'react';
import { Route, Redirect } from 'react-router-dom';

/**
  Component to redirect to Login if a user is not authenticated
*/
const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  isLoading,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        !isLoading && (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      )
    }
  />
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/router/PrivateRoute.js